<template>
  <div class="space-y-8">
    <div>
      <ContactRequestList ref="contactRequestList" :contact-id="contactId" />
    </div>
  </div>
</template>

<script>
import ContactRequestList from './ContactRequestList.vue';

export default {
  components: {
    ContactRequestList,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
};
</script>
